import { Switch } from '@headlessui/react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ToggleSwitchProps {
  enabled: boolean;
  setEnabled: () => void;
  classNames?: string;
  disabled?: boolean;
  toggleButton?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  enabled,
  setEnabled,
  classNames,
  disabled = false,
  toggleButton = '',
}) => {
  const switchClassnames = twMerge(
    'border-2',
    'border-transparent',
    'cursor-pointer',
    'duration-200',
    'ease-in-out',
    'flex-shrink-0',
    'h-6',
    'inline-flex',
    'relative',
    'rounded-full',
    'transition-colors',
    'w-12',
    enabled ? 'bg-kira-blue-800' : 'bg-kira-slate-700',
    disabled && 'cursor-not-allowed',
    disabled && 'opacity-30',
    classNames
  );

  const innerSpanClassnames = twMerge(
    'bg-white',
    'duration-200',
    'ease-in-out',
    'h-5',
    'ring-0',
    'rounded-full',
    'self-center',
    'transform',
    'transition',
    'w-5',
    enabled ? 'translate-x-6' : 'translate-x-0'
  );

  const iconClassNames = twMerge('ml-0.5 w-5 text-white self-center');

  return (
    <Switch.Group as="div" className="flex items-center">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={switchClassnames}
        disabled={disabled}
        data-testid={toggleButton}
      >
        {enabled && <CheckIcon className={`absolute ${iconClassNames}`} />}
        <span className={innerSpanClassnames} />
        {!enabled && <XMarkIcon className={iconClassNames} />}
      </Switch>
    </Switch.Group>
  );
};

export default ToggleSwitch;
